function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var variantSimple = () => {
  return {
    th: {
      background: 'blue.1130',
      borderBottom: '1px solid',
      borderColor: 'grey.300',
      py: 0
    },
    td: {
      py: 0,
      borderBottom: '1px solid',
      borderColor: 'grey.300'
    }
  };
};
var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};
var variantStripe = () => {
  return {
    th: _objectSpread({
      background: 'blue.1130',
      borderBottom: '1px',
      borderColor: 'grey.300'
    }, numericStyles),
    td: _objectSpread({
      borderBottom: '1px',
      borderColor: 'grey.100'
    }, numericStyles),
    caption: {
      color: 'grey.600'
    },
    tbody: {
      tr: {
        '&:nth-of-type(odd)': {
          'th, td': {
            borderBottomWidth: '1px',
            borderColor: 'grey.100'
          },
          td: {
            background: 'grey.100'
          }
        }
      }
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};
var variants = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: {}
};
export var Table = {
  variants
};